/** sessionStorage key written from index.html before Angular boots. */
export const TG_WEBAPP_HASH_KEY = 'eris.tgWebAppHash';

/** Pulls Telegram's signed initData out of a Mini App hash (`#tgWebAppData=...`). */
export function initDataFromHash(hash: string): string {
	if (!hash) return '';
	return new URLSearchParams(hash.replace(/^#/, '')).get('tgWebAppData') ?? '';
}

/**
 * Restores the hash Telegram stamped if Angular already stripped it, then
 * returns initData from the live hash or from the copy saved at boot.
 */
export function recoverTelegramInitData(
	locationLike: { hash: string; pathname: string; search: string } = window.location,
	storage: Pick<Storage, 'getItem'> | null = typeof sessionStorage === 'undefined' ? null : sessionStorage,
	replaceHash?: (hash: string) => void,
): string {
	const stored = storage?.getItem(TG_WEBAPP_HASH_KEY) ?? '';
	if (stored && !locationLike.hash.includes('tgWebAppData')) {
		const restore =
			replaceHash ??
			((hash: string) => {
				history.replaceState(null, '', `${locationLike.pathname}${locationLike.search}${hash}`);
			});
		restore(stored);
	}
	return initDataFromHash(locationLike.hash) || initDataFromHash(stored);
}

/** Telegram Web K delivers initData over postMessage after the iframe paints. */
export const INIT_DATA_WAIT_MS = 2000;
export const INIT_DATA_POLL_MS = 100;

/**
 * Polls until signed initData appears, or the budget runs out. Empty string
 * means it never arrived (opened outside Telegram, or the webview stayed mute).
 */
export async function waitForTelegramInitData(
	read: () => string,
	pause: (ms: number) => Promise<void>,
	budgetMs = INIT_DATA_WAIT_MS,
	stepMs = INIT_DATA_POLL_MS,
): Promise<string> {
	let elapsed = 0;
	while (true) {
		const data = read().trim();
		if (data) return data;
		if (elapsed >= budgetMs) return '';
		await pause(stepMs);
		elapsed += stepMs;
	}
}
